import { CouponType } from "@interfaces/dto/coupon.dto";
import { CouponImage } from "./CouponItem";

type Props = {
  couponDetail: {
    coupon: string;
    name: string;
    campaign_name: string;
    from_date: string;
    to_date: string;
    description: string;
    usage_limit?: boolean;
    status?: boolean;
    image_url?: string;
  };
  selectedStatus?: CouponType | undefined;
};

const Detail = ({ couponDetail, selectedStatus }: Props) => {
  const decodeHtml = (text: string | undefined) => {
    if (text === undefined) return "-";
    return text.replace(/\r\n/g, "<br>");
  };

  return (
    <>
      <div className="list-coupon mx-0 mx-sm-3 mb-4">
        <div className="d-flex mb-3 border rounded">
          <div className="img-coupon-detail d-flex justify-content-center ms-3 py-2">
            <i
              style={CouponImage(couponDetail)}
              className={`icon ${
                selectedStatus === "coupon_used" ||
                selectedStatus === "coupon_expired" ||
                couponDetail.status === false
                  ? "icon-coupon-disable"
                  : "icon-coupon-enable"
              }  my-auto img-fluid`}
            />
          </div>
          <div className="w-100 p-0 mx-3 mx-sm-4 my-auto">
            <p className="m-0 lh-base">
              <b>คูปอง</b>{" "}
              <b
                className={
                  selectedStatus === "coupon_used" ||
                  selectedStatus === "coupon_expired" ||
                  couponDetail.status === false
                    ? "text-secondary"
                    : "text-red"
                }
              >
                {couponDetail.coupon}
              </b>
              <br />
              <small>{couponDetail.campaign_name}</small> <br />
              <small className="coupon-date text-secondary">
                ระยะเวลาการใช้งาน : {couponDetail.from_date} -{" "}
                {couponDetail.to_date}
              </small>
            </p>
          </div>
        </div>
        <div className="mx-3">
          <div className="lh-lg"></div>
          <p
            dangerouslySetInnerHTML={{
              __html: decodeHtml(couponDetail.description),
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Detail;
